__turbopack_context__.v({
  "actions": "NoAvatarCard-module__B5A9qq__actions",
  "badge": "NoAvatarCard-module__B5A9qq__badge",
  "card": "NoAvatarCard-module__B5A9qq__card",
  "content": "NoAvatarCard-module__B5A9qq__content",
  "description": "NoAvatarCard-module__B5A9qq__description",
  "header": "NoAvatarCard-module__B5A9qq__header",
  "iconContainer": "NoAvatarCard-module__B5A9qq__iconContainer",
  "title": "NoAvatarCard-module__B5A9qq__title",
});
